<template>
  <b-card-body>
    <b-row>
      <b-col>
        <h5>{{ $t('question') }}</h5>
        <b-input-group style="margin-bottom: 25px;">
          <b-form-textarea readonly rows="1" v-model="question.text"></b-form-textarea>
        </b-input-group>
        <h5>{{ $t('questionalternative') }}</h5>
        <b-list-group v-for="(alternative, alternativeIndex) in question.alternatives" :key="alternativeIndex">
          <b-row>
            <b-col>
              <b-form-textarea readonly rows="1" v-model="alternative.text" />
            </b-col>
          </b-row>
        </b-list-group>
      </b-col>
    </b-row>
  </b-card-body>
</template>

<script>

export default {
  name: 'display-module-bp',
  props: {
    question: {}
  }
}
</script>
